import * as React from 'react';

interface FormCheckBoxTypes {
	options?: { label?: string; value?: string }[];
	values: string[];
	onChange?: any;
}

export const FormCheckBox: React.FC<FormCheckBoxTypes> = ({ options, values, onChange }) => {
	const [selectedValues, setSelectedValues] = React.useState<string[]>([]);

	const handleChange = (value: string) => {
		const selectedValue = value.toString();
		const selectedValueIndex = selectedValues.indexOf(selectedValue);
		const newValues = selectedValues.slice();

		if (selectedValueIndex !== -1) {
			newValues.splice(selectedValueIndex, 1);
		} else {
			newValues.push(selectedValue);
		}

		setSelectedValues(newValues);

		if (onChange) {
			onChange(newValues);
		}
	};

	React.useEffect(() => {
		if (values && values.length) {
			setSelectedValues(values);
		}
	}, [values]);

	return (
		<>
			{options && options.length && options && (
				<div className="multi-select-options">
					<ul>
						{options.map((option, index) => (
							<li key={index}>
								<label className="form-control-checkbox">
									<input
										type="checkbox"
										value={option.value}
										checked={selectedValues.includes(option.value !== undefined ? option.value : '')}
										onChange={() => {
											handleChange(option.value !== undefined ? option.value : '');
										}}
									/>
									
									<span>{option.label}</span>
								</label>
							</li>
						))}
					</ul>
				</div>
			)}
		</>
	);
};

export default FormCheckBox;
